import { render, staticRenderFns } from "./IconColor.vue?vue&type=template&id=119f413a"
import script from "./IconColor.vue?vue&type=script&lang=js"
export * from "./IconColor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports